import { type IGetWagerListUseCase, type IWagerService, NotFoundError } from '../../../domain/entry.js';

/**
 * Use case for getting wager list items.
 *
 * @param wagerService Wager service dependency
 * @returns Use case executor for getting wagers
 */
export function getWagerListUseCase(wagerService: IWagerService): IGetWagerListUseCase {
  return {
    execute: async ({ product, queryDetails }): ReturnType<IGetWagerListUseCase['execute']> => {
      const wagers = await wagerService.getWagersAsync(product, queryDetails);

      if (!wagers) {
        throw new NotFoundError(`Wagers not found for product ${product}`);
      }

      return wagers;
    },
  };
}
